import {useMutation} from "@tanstack/react-query";

import {updateMaterialCompositionMutationOptions} from "./update-material-composition.mutation-options";

export function useUpdateMaterialComposition(id: string) {
  return useMutation(updateMaterialCompositionMutationOptions(id));
}
